import React from "react";
import i18n from "@microdoing/shared/i18n";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from "react-native-responsive-screen";
import Modal from "react-native-modal";
import { MainTitle, Box, MainText, MainButton } from "app/components/common";
import achievementBadges from "../../scenes/UserProfile/Badges/achievementBadges";
import Stars from "./Stars";
import normalize from "app/utils/normalize";
import { isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";

const MAX_WIDTH = isWebDesktop ? 400 : "96%";

interface Props {
  isVisible?: boolean;
  triggerModal: () => void;
  title: string;
  name: string;
  isEmpty?: boolean;
  level: number;
  isDone: boolean;
}

const AchievementModal = ({
  isVisible = false,
  triggerModal = () => null,
  name = "",
  title = "",
  isEmpty = false,
  level = 0,
  isDone = false,
}: Props) => {
  return (
    <Modal
      animationInTiming={250}
      backdropTransitionOutTiming={0}
      animationOutTiming={200}
      isVisible={isVisible}
      hideModalContentWhileAnimating
      avoidKeyboard
      useNativeDriver
      onBackdropPress={triggerModal}
    >
      <Box
        maxWidth={MAX_WIDTH}
        alignSelf="center"
        maxHeight={hp("80%")}
        backgroundColor="neutral.white"
        alignItems="center"
        justifyContent="center"
        borderRadius={8}
        padding="l"
        paddingVertical="sm"
      >
        <MainTitle
          textAlign="center"
          fontWeight="bold"
          color="neutral.900"
          marginBottom="sl"
          marginTop="s"
          variant="l7-bold"
        >
          {title}
        </MainTitle>
        <Box justifyContent="center" alignItems="center">
          {achievementBadges[isEmpty || !name ? "empty" : name](normalize(125))}
          <Box marginTop="sl" marginBottom="sm">
            <Stars level={level} />
          </Box>
        </Box>
        <MainText variant="l4-semibold" color="neutral.900">
          {i18n.t(`achievement-${name}`)}
        </MainText>
        <MainText
          variant="l4-medium"
          marginTop="s"
          textAlign="center"
          color="neutral.500"
          paddingHorizontal="sm"
        >
          {isDone || level > 2
            ? i18n.t(`achievement-${name}-done-${level}`)
            : i18n.t(`achievement-${name}-next-${level}`)}
        </MainText>
        <MainButton marginTop="m" text={i18n.t("ok")} onPress={triggerModal} />
      </Box>
    </Modal>
  );
};

export default AchievementModal;
